<template>
    <div class="row" v-if="isValid('CanViewReparingOrder')">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto">
            <div class="row mb-4">
                <div class="col-lg-6" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">
                    <h5 class="page_title">{{ $t('ReparingOrder.ReparingOrder') }}</h5>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link :to="'/StartScreen'"><a href="javascript:void(0)"> {{ $t('Purchase.Home') }}</a></router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">{{ $t('ReparingOrder.ReparingOrder') }}</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-lg-6 ">
                    <div v-bind:class="$i18n.locale == 'en' ? 'text-right' : 'text-left'" class="col-md-12">
                        <a href="javascript:void(0)" class="btn btn-outline-primary " v-shortkey="[ 'enter']" @shortkey="AddPurchaseOrder" v-on:click="AddPurchaseOrder" v-if="isValid('CanAddReparingOrder')"><i class="fa fa-plus"></i>  {{ $t('Purchase.AddNew') }}</a>
                        <router-link :to="'/StartScreen'"><a href="javascript:void(0)" class="btn btn-outline-danger "> {{ $t('Purchase.Close') }}</a></router-link>
                    </div>
                </div>
            </div>
            <div class="card ">
                <div class="card-header">

                    <div class="row mb-3" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group ">
                                <label>{{ $t('ReparingOrder.SearchByReparingOrder')}}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'" name="search" id="search" :placeholder="$t('Purchase.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <!--<div v-bind:class="$i18n.locale == 'en' ? 'text-right' : 'text-left'" >
                                <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="ImportDataFromXlsx">Import Record</a>
                            </div>-->
                        </div>
                        <!--<div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label>{{ $t('Purchase.FromDate') }}</label>
                                <datepicker v-model="fromDate" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label>{{ $t('Purchase.ToDate') }}</label>
                                <datepicker v-model="toDate" />
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>

            <div class="card" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">

                            <ul class="nav nav-tabs" data-tabs="tabs">
                                <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'All'}" v-on:click="makeActive('All')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">All</a></li>
                                <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'InProgress'}" v-on:click="makeActive('InProgress')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">In Progress</a></li>
                                <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'Repared'}" v-on:click="makeActive('Repared')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Repared</a></li>
                                <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'PaymentReceived'}" v-on:click="makeActive('PaymentReceived')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Payment Received</a></li>

                                <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'Returned'}" v-on:click="makeActive('Returned')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Returned</a></li>
                                <li class="nav-item"><a class="nav-link" v-bind:class="{active:active == 'CompletedOrders'}" v-on:click="makeActive('CompletedOrders')" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">Completed Orders</a></li>

                            </ul>
                            <div class="tab-content mt-3" id="nav-tabContent">
                                <div v-if="active == 'All'">

                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
 <!--<th style="width:40px;">#</th>-->
                                                    <th class="text-center">
                                                        Reparing Order No
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Date Received
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Employee
                                                    </th>



                                                    <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Customer
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Mobile
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        UPS Desc
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Issue
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.Status') }}
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Acessories
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Done By
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Amount
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Payment
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Balance
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'" style="width:135px !important">
                                                        {{ $t('Purchase.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(purchase) in purchasePostList" v-bind:key="purchase.id">
                                                    <!--<td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*1000)-1000) +(index+1)}}
                                                    </td>-->
                                                    <td class="text-center" v-if="isValid('CanEditReparingOrder')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditPurchaseOrder(purchase.id,false)">  {{purchase.registrationNo}}</a>
                                                        </strong>
                                                    </td>
                                                    <td class="text-center" v-else>
                                                        <strong>
                                                            {{purchase.registrationNo}}
                                                        </strong>
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.dates}}
                                                    </td>

                                                    <td>
                                                        {{purchase.employeeNameEn}}

                                                    </td>


                                                    <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.customerNameEn}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.mobile}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.upsDes}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.issue}}
                                                    </td>
                                                    <td>
                                                        {{purchase.status}}

                                                    </td>
                                                    <td>
                                                        {{purchase.accessor}}

                                                    </td>
                                                    <td>
                                                        {{purchase.doneBy}}

                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.advanceAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.cashAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.remaningPrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm " v-on:click="EditPurchaseOrder(purchase.id,true)"><i class=" fas fa-eye"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,true)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,false)"><i class=" fa fa-print"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 1000">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1000 && rowCount >= 1001  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-if="$i18n.locale == 'en'">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="active == 'InProgress'">

                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
 <!--<th style="width:40px;">#</th>-->
                                                    <th class="text-center">
                                                        Reparing Order No
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Date Received
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Employee
                                                    </th>



                                                    <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Customer
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Mobile
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        UPS Desc
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Issue
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.Status') }}
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Acessories
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Done By
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Amount
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Payment
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Balance
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(purchase) in purchasePostList" v-bind:key="purchase.id">
                                                    <!--<td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*1000)-1000) +(index+1)}}
                                                    </td>-->
                                                    <td class="text-center" v-if="isValid('CanEditReparingOrder')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditPurchaseOrder(purchase.id,false)">  {{purchase.registrationNo}}</a>
                                                        </strong>
                                                    </td>
                                                    <td class="text-center" v-else>
                                                        <strong>
                                                           {{purchase.registrationNo}}
                                                        </strong>
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.dates}}
                                                    </td>

                                                    <td>
                                                        {{purchase.employeeNameEn}}

                                                    </td>


                                                    <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.customerNameEn}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.mobile}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.upsDes}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.issue}}
                                                    </td>
                                                    <td>
                                                        {{purchase.status}}

                                                    </td>
                                                    <td>
                                                        {{purchase.accessor}}

                                                    </td>
                                                    <td>
                                                        {{purchase.doneBy}}

                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.advanceAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.cashAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.remaningPrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm " v-on:click="EditPurchaseOrder(purchase.id,true)"><i class=" fas fa-eye"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,true)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,false)"><i class=" fa fa-print"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 1000">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1000 && rowCount >= 1001  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-if="$i18n.locale == 'en'">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="active == 'Repared'">

                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
                                                    <!--<th style="width:40px;">#</th>-->
                                                    <th class="text-center">
                                                        Reparing Order No
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Date Received
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Employee
                                                    </th>



                                                    <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Customer
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Mobile
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        UPS Desc
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Issue
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.Status') }}
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Acessories
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Done By
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Amount
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Payment
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Balance
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(purchase) in purchasePostList" v-bind:key="purchase.id">
                                                    <!--<td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*1000)-1000) +(index+1)}}
                                                    </td>-->
                                                    <td class="text-center" v-if="isValid('CanEditReparingOrder')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditPurchaseOrder(purchase.id,false)">  {{purchase.registrationNo}}</a>
                                                        </strong>
                                                    </td>
                                                    <td class="text-center" v-else>
                                                        <strong>
                                                             {{purchase.registrationNo}}
                                                        </strong>
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.dates}}
                                                    </td>

                                                    <td>
                                                        {{purchase.employeeNameEn}}

                                                    </td>


                                                    <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.customerNameEn}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.mobile}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.upsDes}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.issue}}
                                                    </td>
                                                    <td>
                                                        {{purchase.status}}

                                                    </td>
                                                    <td>
                                                        {{purchase.accessor}}

                                                    </td>
                                                    <td>
                                                        {{purchase.doneBy}}

                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.advanceAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.cashAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.remaningPrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm " v-on:click="EditPurchaseOrder(purchase.id,true)"><i class=" fas fa-eye"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,true)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,false)"><i class=" fa fa-print"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 1000">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1000 && rowCount >= 1001  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-if="$i18n.locale == 'en'">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="active == 'Returned'">

                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
 <!--<th style="width:40px;">#</th>-->
                                                    <th class="text-center">
                                                        Reparing Order No
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Date Received
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Employee
                                                    </th>



                                                    <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Customer
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Mobile
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        UPS Desc
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Issue
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.Status') }}
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Acessories
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Done By
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Amount
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Payment
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Balance
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(purchase) in purchasePostList" v-bind:key="purchase.id">
                                                    <!--<td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*1000)-1000) +(index+1)}}
                                                    </td>-->
                                                    <td class="text-center" v-if="isValid('CanEditReparingOrder')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditPurchaseOrder(purchase.id,false)">  {{purchase.registrationNo}}</a>
                                                        </strong>
                                                    </td>
                                                    <td class="text-center" v-else>
                                                        <strong>
                                                            {{purchase.registrationNo}}
                                                        </strong>
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.dates}}
                                                    </td>

                                                    <td>
                                                        {{purchase.employeeNameEn}}

                                                    </td>


                                                    <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.customerNameEn}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.mobile}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.upsDes}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.issue}}
                                                    </td>
                                                    <td>
                                                        {{purchase.status}}

                                                    </td>
                                                    <td>
                                                        {{purchase.accessor}}

                                                    </td>
                                                    <td>
                                                        {{purchase.doneBy}}

                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.advanceAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.cashAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.remaningPrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm " v-on:click="EditPurchaseOrder(purchase.id,true)"><i class=" fas fa-eye"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,true)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,false)"><i class=" fa fa-print"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 1000">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1000 && rowCount >= 1001  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-if="$i18n.locale == 'en'">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="active == 'PaymentReceived'">

                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
 <!--<th style="width:40px;">#</th>-->
                                                    <th class="text-center">
                                                        Reparing Order No
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Date Received
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Employee
                                                    </th>



                                                    <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Customer
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Mobile
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        UPS Desc
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Issue
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.Status') }}
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Acessories
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Done By
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Amount
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Payment
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Balance
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(purchase) in purchasePostList" v-bind:key="purchase.id">
                                                    <!--<td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*1000)-1000) +(index+1)}}
                                                    </td>-->
                                                    <td class="text-center" v-if="isValid('CanEditReparingOrder')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditPurchaseOrder(purchase.id,false)">  {{purchase.registrationNo}}</a>
                                                        </strong>
                                                    </td>
                                                    <td class="text-center" v-else>
                                                        <strong>
                                                            {{purchase.registrationNo}}
                                                        </strong>
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.dates}}
                                                    </td>

                                                    <td>
                                                        {{purchase.employeeNameEn}}

                                                    </td>


                                                    <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.customerNameEn}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.mobile}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.upsDes}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.issue}}
                                                    </td>
                                                    <td>
                                                        {{purchase.status}}

                                                    </td>
                                                    <td>
                                                        {{purchase.accessor}}

                                                    </td>
                                                    <td>
                                                        {{purchase.doneBy}}

                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.advanceAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.cashAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.remaningPrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm " v-on:click="EditPurchaseOrder(purchase.id,true)"><i class=" fas fa-eye"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,true)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,false)"><i class=" fa fa-print"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 1000">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1000 && rowCount >= 1001  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-if="$i18n.locale == 'en'">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="active == 'CompletedOrders'">

                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                            <thead class="">
                                                <tr>
 <!--<th style="width:40px;">#</th>-->
                                                    <th class="text-center">
                                                        Reparing Order No
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Date Received
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Employee
                                                    </th>



                                                    <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Customer
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Mobile
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        UPS Desc
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Issue
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.Status') }}
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Acessories
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Done By
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Amount
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Payment
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        Balance
                                                    </th>
                                                    <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{ $t('Purchase.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(purchase) in purchasePostList" v-bind:key="purchase.id">
                                                    <!--<td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*1000)-1000) +(index+1)}}
                                                    </td>-->
                                                    <td class="text-center" v-if="isValid('CanEditReparingOrder')">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditPurchaseOrder(purchase.id,false)">  {{purchase.registrationNo}}</a>
                                                        </strong>
                                                    </td>
                                                    <td class="text-center" v-else >
                                                        <strong>
                                                            {{purchase.registrationNo}}
                                                        </strong>
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.dates}}
                                                    </td>

                                                    <td>
                                                        {{purchase.employeeNameEn}}

                                                    </td>


                                                    <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.customerNameEn}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.mobile}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.upsDes}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{purchase.issue}}
                                                    </td>
                                                    <td>
                                                        {{purchase.status}}

                                                    </td>
                                                    <td>
                                                        {{purchase.accessor}}

                                                    </td>
                                                    <td>
                                                        {{purchase.doneBy}}

                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.advanceAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.cashAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        {{currency}}   {{parseFloat(purchase.remaningPrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm " v-on:click="EditPurchaseOrder(purchase.id,true)"><i class=" fas fa-eye"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,true)"><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" class="btn  btn-icon btn-primary btn-sm mr-1 ml-1" v-on:click="PrintInvoice(purchase.id,false)"><i class=" fa fa-print"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 1000">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1000 && rowCount >= 1001  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*1000}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{currentPage*1000}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*1000)-999}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-if="$i18n.locale == 'en'">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" :key="randerList" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="1000"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>

                                </div>




                            </div>


                           
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <ReparingOrderThermalPrint :printDetails="printDetails" :headerFooter="headerFooter" v-if="isPrint" v-bind:key="printRander" />
        <ReparingOrderPaymentPrint :printDetails="printDetails" :headerFooter="headerFooter" v-if="isPrint2" v-bind:key="printRander2" />
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>

<script>
    import clickMixin from '@/Mixins/clickMixin';
    import moment from "moment";


    export default {
        mixins: [clickMixin],

        data: function () {
            return {
                expenseToGst: '',
                fromDate: '',
                toDate: '',
                arabic: '',
                english: '',
                active: 'All',
                search: '',
                searchQuery: '',
                purchaseOrderList: [],
                purchasePostList: [],
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                currency: '',
                selected: [],
                selectAll: false,
                isPrint: false,
                isPrint2: false,
                printRander: 0,
                printRander2: 0,
                updateApprovalStatus: {
                    id: '',
                    approvalStatus: ''
                },
                isMultiUnit: false,
                download: false,
                printDetails: [],
                printRender: 0,
                counter: 0,
                randerList: 0,
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
            }
        },
        watch: {
            search: function (val) {

                {
                    this.getPostData(val, this.currentPage, this.active);
                }
            },

        },
        methods: {
            ImportDataFromXlsx: function () {
                debugger;
                var root = this;
                root.$router.push({
                    path: '/ImportReparingOrder',
                })
            },
            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            debugger;
                            root.getBase64Image(root.headerFooter.company.logoPath);


                        }
                    });
            },

            makeActive: function (item) {
                this.active = item;
                this.getPostData(this.search, this.currentPage, this.active);
            },

            getPage: function () {
                this.getPostData(this.search, this.currentPage, this.active);
            },
            getDate: function (date) {
                if (date == null || date == undefined) {
                    return "";
                }
                else {
                    return moment(date).format('L');
                }
            },

            getPostData: function (search, currentPage, status) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
               

                this.$https.get('/ReparingOrder/ReparingOrderList?status=' + status + '&searchTerm=' + search + '&pageNumber=' + currentPage, { headers: { "Authorization": `Bearer ${token}` } })

                    .then(function (response) {
                        if (response.data != null) {
                            root.purchasePostList = response.data.results;
                            root.pageCount = response.data.pageCount;
                            root.rowCount = response.data.rowCount;
                            root.currentPage = currentPage;
                            root.randerList++;
                        }
                    });
            },

            AddPurchaseOrder: function () {

                //if (localStorage.getItem("BarcodeScan") != 'ReparingOrder')
                //    return
                this.$router.push('/AddReparingOrder');
            },
            EditPurchaseOrder: function (id, isView) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/ReparingOrder/ReparingOrderDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            debugger;
                            root.$router.push({
                                path: '/AddReparingOrder',
                                query: {
                                    data: response.data,
                                    isView: isView
                                }
                            })
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },
            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                debugger;
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }
                    });
            },
            PrintInvoice: function (value, isPrint) {
                var id = value;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                //this.GetHeaderDetail();
                root.$https.get("/ReparingOrder/ReparingOrderDetail?Id=" + id, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {

                            root.printDetails = response.data;
                            if (isPrint) {
                                root.isPrint = true;

                                root.printRander++;
                            }
                            else {
                                root.isPrint2 = true;

                                root.printRander2++;
                            }




                        }
                    });
            }
        },
        created: function () {
            //var root = this;
            //localStorage.setItem("BarcodeScan", 'ReparingOrder')

            //if (localStorage.getItem("BarcodeScan") != 'ReparingOrder')
            //    return

            //var interval;
            //document.addEventListener('keydown', function (evt) {
            //    if (interval)
            //        clearInterval(interval);
            //    if (evt.code === 'Enter') {

            //        root.AddPurchaseOrder();



            //    }
            //    else
            //        return;

            //});




        },
        mounted: function () {
            debugger;
            this.GetHeaderDetail();
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.getPostData(this.search, 1, 'All');
        },
    }
</script>